import { Component, ViewEncapsulation, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';

@Component({
  selector: 'mc-task-asset-icon',
  templateUrl: './task-asset-icon.component.html',
  styleUrls: ['./task-asset-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TaskAssetIconComponent implements OnInit, OnChanges {
  @Input() count: number;
  @Input() size = 'normal';
  @Input() displayParenthesis: boolean;
  sizeClass: string;
  constructor() { }

  ngOnInit(): void {
    this.sizeClass = `mc-task-asset-icon-${this.size}`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['size']) {
      this.sizeClass = `mc-task-asset-icon-${this.size}`;
    }
  }
}
